import { Provider } from "@angular/core";
import { ROUTE_HOOK, RouteHook } from "@obg/ngx.global.evo";
import { flatMap } from "lodash-es";

import { RouteConfig, ROUTER_CONFIG, RouterConfig } from "./config/router-config.model";
import { removeDisabledRoutes } from "./config/router-config.util";
import { LocalizeRouterService } from "./localize/localize-router.service";

export const LOCALIZE_ROUTES_PROVIDER: Provider = {
	provide: ROUTE_HOOK,
	multi: true,
	useFactory: _localizeRoutesFactory,
	deps: [LocalizeRouterService],
};

export function _localizeRoutesFactory(service: LocalizeRouterService): RouteHook<RouteConfig> {
	return {
		prio: 1,
		process: (routes) => service.localizeRoutes(routes),
	};
}

export const REMOVE_DISABLED_ROUTES_PROVIDER: Provider = {
	provide: ROUTE_HOOK,
	multi: true,
	useFactory: _removeDisableRoutesFactory,
	deps: [ROUTER_CONFIG],
};

export function _removeDisableRoutesFactory(config: RouterConfig): RouteHook<RouteConfig> {
	const { disabledRoutes } = config;

	return {
		prio: 0,
		process: (routes) => removeDisabledRoutes(flatMap(routes), disabledRoutes),
	};
}
